module.exports = __webpack_public_path__ + "static/media/logo-ministerio-fazenda.46edb62f.png";